import { useState } from "react";
import { IconType } from "../../icons/Icon";
import { IconButton } from "../button/iconButton/IconButton";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import { WorkoutPlanDialog } from "./WorkoutPlanDialog";
import { WorkoutPlanDialogMode } from "./models/workoutPlanViewModel";

interface IWorkoutPlanButtonProps {
  eventId: number;
  mode: WorkoutPlanDialogMode;
  registeredUserName?: string;
  eventDateLabel?: string;
  eventTimeLabel?: string;
  /** "icon" = compact button for admin action bars; "button" = full-width DefaultButton for portal. */
  variant?: "icon" | "button";
  design?: "default" | "secondary" | "outline" | "neutral" | "accent" | "link";
  label?: string;
  iconHeight?: string;
  iconWidth?: string;
  tooltip?: string;
}

export const WorkoutPlanButton = ({
  eventId,
  mode,
  registeredUserName,
  eventDateLabel,
  eventTimeLabel,
  variant = "icon",
  design = "secondary",
  label = "Тренировъчна програма",
  iconHeight = "30px",
  iconWidth = "30px",
  tooltip = "Тренировъчна програма",
}: IWorkoutPlanButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {variant === "icon" ? (
        <IconButton
          iconType={IconType.Dumbell}
          iconHeight={iconHeight}
          iconWidth={iconWidth}
          tooltip={tooltip}
          onClick={() => setIsOpen(true)}
        />
      ) : (
        <DefaultButton
          onClick={() => setIsOpen(true)}
          label={label}
          design={design}
        />
      )}
      <WorkoutPlanDialog
        visible={isOpen}
        onHide={() => setIsOpen(false)}
        eventId={eventId}
        registeredUserName={registeredUserName}
        eventDateLabel={eventDateLabel}
        eventTimeLabel={eventTimeLabel}
        mode={mode}
      />
    </>
  );
};
